// @flow
import React from 'react'
import {observer} from 'mobx-react'
import componentStore from 'stores/components'
import styled from 'styled-components'
import alertStore from 'stores/alert'
import storyStore from 'stores/storybook'

type Props = {|
  history: {push:(path:string)=>void}
|}

type State = {
  active: string | null
}

export default observer(class ComponentList extends React.Component<Props,State> {
  state = {active: null }
  setActive = component => () => this.setState({active: component.id})

  componentDidMount(){
    window.__lastLocation = window.location.pathname
  }

  removeComponent = (component:*) => {
    alertStore.set({
      title: `löschen (${component.props.gridArea})`,
      body: `Du bist kurz davor eine Komponente zu löschen. Bist du dir sicher?`,
      onOk: () => componentStore.removeComponent(component)
    })
  }
  render(){
    const {push} = this.props.history
    const {active} = this.state
    return (
      <Wrapper className='ComponentList'>
        {componentStore.components.map(component => (
          <Component 
            inUse={!componentStore.unusedDict[component.id]}
            key={component.id}
            children={(
              <div className='content'>
                {active !== component.id && (
                  <div className='info' onClick={this.setActive(component)}>
                    <h3 className='name'>{component.name}</h3>
                    <p className='grid-name'>{component.props.gridArea}</p>
                  </div>)}
                {active === component.id && (
                  <ButtonList>
                    <button className='edit' onClick={() => storyStore.setComponent(component.id)}>Edit</button>
                    <button className='delete' onClick={() => this.removeComponent(component)}>Delete</button>
                  </ButtonList>)}
              </div>
            )}
          />
        ))}
        <Component inUse>
          <div className='content'>
            <div className='plus-wrapper' onClick={() => storyStore.setComponent('new-component')}>
              <span>+</span>
            </div>
          </div>
        </Component>
      </Wrapper>
    )
  }
})

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  > * {margin: 15px;}
`

const Component = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > .content {
    width: 320px;
    height: 100px;
    padding: 0px 10px;
    box-sizing: border-box;
    background: ${props => props.inUse ? '#596f79' : '#e91e63'};
    border: 2px solid lightgrey;
    border-radius: 5px;

    color: whitesmoke;

    ${props => !props.active && `
      &:hover {opacity: .7; cursor:pointer;}
    `}

    > .plus-wrapper {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 80px;
      margin-top: -5px;
    }

  }
`

const ButtonList = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-evenly;

  > button {
    border: none;
    background: none;
    padding: 8px;
    font-size: 14px;
    color: #f8f8f9;
    border-radius: 5px;
    &:hover {opacity: .7; cursor:pointer;}
  }

  > .edit {
    background: #3a843d;
  }

  > .delete {
    background: #e42b1e;
  }
`


// WEBPACK FOOTER //
// ./src/routes/ComponentList.js